export const formatDate = (date: any) => {
    if (!date) return '';
    const formattedDate = new Date(date).toISOString().slice(0, 10);
    return formattedDate;
};
